<template>
  <div class="animated fadeIn">
    <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
    <b-form>
      <b-form-group
        label="Donation Amount"
        description="Donation Amount"
        :label-cols="3"
        :horizontal="true">
        <b-form-input type="number" placeholder="Membership Amount" v-model="donation.amount"></b-form-input>
        <validation-errors :errors="donation.errors" field="amount"></validation-errors>
      </b-form-group>
      <b-form-group
        label="Donation Status"
        description="Donation Status"
        :label-cols="3"
        :horizontal="true"
        v-if="!addOption"
      >
        <app-btn :text="donation.status"></app-btn>
      </b-form-group>
      <b-form-group
        label="Subscribe to NewsLetter"
        description="Subscribe person to Graffitti News Letter"
        v-if="addOption"
        :label-cols="3"
        :horizontal="true">
        <b-form-checkbox placeholder="Subscribe person to Graffitti News Letter" v-model="donation.subscribeToNewsLetter"></b-form-checkbox>
      </b-form-group>
      <strong>Person Details</strong>
      <b-form-group validated
                    label="Person Name"
                    label-for="subscriberName"
                    description="Please enter person name."
                    :label-cols="3"
                    :horizontal="true">
        <b-form-input id="personName" type="text" placeholder="Enter Name.." v-model="donation.person.name"></b-form-input>
      </b-form-group>
      <b-form-group
        label="Person Surname"
        label-for="subscriberSurname"
        description="Please enter person surname."
        :label-cols="3"
        :horizontal="true">
        <b-form-input id="personSurname" type="text" placeholder="Enter Surname.." v-model="donation.person.surname" autocomplete="surname"></b-form-input>
      </b-form-group>
      <b-form-group
        description="Enter the person email."
        label="Person Email"
        :label-cols="3"
        :horizontal="true">
        <b-form-input  type="email" v-model="donation.person.email"  placeholder="Enter Email.."  required></b-form-input>
      </b-form-group>
      <b-form-group
        description="Enter the person mobile."
        label="Person Mobile"
        :label-cols="3"
        :horizontal="true">
        <b-form-input  type="text" v-model="donation.person.mobile"></b-form-input>
      </b-form-group>
      <div slot="footer">
        <donation-add-button
          :donation="donation"
          :disabled="validationPassed"
          v-if="addOption"
          @click="onBtnClick"
        ></donation-add-button>
      </div>
    </b-form>
  </div>
</template>

<script>
  import VueLoading from "vue-loading-overlay/src/js/Component";
  import {Donation} from "../../models/Donation";
  import DonationAddButton from "./button/DonationAddButton";
  import ValidationErrors from "../base/ValidationErrors";
  import AppBtn from "../base/AppBtn";

  export default {
    name: 'donation-form',
    components: {
      AppBtn,
      ValidationErrors,
      DonationAddButton,
      VueLoading,
    },
    data() {
      return {
        isLoading: false,
        validationPassed: false,
      }
    },
    props: {
      donation: {
        type: Object,
        default: new Donation(),
      },
      addOption: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      'donation.errors': {
        handler(errors) {
          let keys = Object.keys(errors)
          if (keys.length >= 1) {
            this.validationPassed = true
            return
          }
          this.validationPassed = false
        }
      }
    },
    methods: {
      onBtnClick(){
        this.isLoading = this.isLoading ? false : true
      },
    }
  }
</script>
